import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AppLayout from "@amzn/awsui-components-react-v3/polaris/app-layout";
import AddSeatsPage from '../../components/AddSeats/AddSeats';
import { useNavigate } from 'react-router-dom';
import { Flashbar } from '@amzn/awsui-components-react-v3';
export const AddSeatsPageLayout = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [notification, setNotification] = useState();
    useEffect(() => {
        if (notification) {
            setItems([
                {
                    type: notification?.type,
                    dismissible: true,
                    content: notification?.text,
                    onDismiss: () => {
                        setItems([]);
                    },
                }
            ]);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }, [notification]);
    return (_jsx(AppLayout, { content: _jsx(AddSeatsPage, { setNotification: setNotification }), toolsHide: true, navigationHide: true, notifications: _jsx(Flashbar, { items: items }) }));
};
export default AddSeatsPageLayout;
